
import { NetworkRule } from "@/hooks/useNetworkRules";

export interface GroupedRule {
  appName: string;
  bundleId: string;
  iconUrl?: string;
  rules: NetworkRule[];
}

// This utility is no longer needed since we removed Bundle ID rules as a separate type
// Bundle IDs are now just an optional field on system-wide rules
export const isBundleIdRule = (rule: NetworkRule): boolean => {
  return false; // No longer used
};
